let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2QxRm")).then(() => parcelRequire('jJ5VA'));